import script from "./PdfCom.vue?vue&type=script&setup=true&lang=js"
export * from "./PdfCom.vue?vue&type=script&setup=true&lang=js"

import "./PdfCom.vue?vue&type=style&index=0&id=42daa001&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42daa001"]])

export default __exports__